import { useState } from 'react';

import { rewriteImageSrc } from '@/utils/rewriteImageSrc';
import { Image } from '../image';
import { getBackgroundDarkenStyle } from '../utils/background';
import type { BackgroundImageProps } from './backgroundImage.type';

export function BackgroundImage({
  src,
  darken,
  optimizable,
  optimizedImageComponent: ImageComponentProp,
}: BackgroundImageProps) {
  const [isError, setIsError] = useState(false);

  if (!src) return null;

  const ImageComp = ImageComponentProp || Image;
  return (
    <ImageComp
      src={rewriteImageSrc(src)}
      alt="background"
      layout="fill"
      objectFit="cover"
      objectPosition="center"
      priority
      onError={() => setIsError(true)}
      unoptimized={!optimizable || isError ? true : undefined}
      quality={100}
      style={{
        width: '100%',
        height: '100%',
        ...getBackgroundDarkenStyle(darken),
      }}
    />
  );
}
